import { GAME_EVENTS } from '@kulee/tga-constant'
import BaseModule from './BaseModule'
import logger from './logger'
import type { Callback, CallbackData } from './types'

class Rank extends BaseModule {
  /**
   * 选接
   * 上报用户当前积分
   * @param options 积分信息
   */
  public reportRankScore(options: { scoreInfo: { rankId: string; score: number }; callback: Callback }): void {
    logger.info(`report score`, options)

    const { scoreInfo, callback } = options

    if (!scoreInfo.score || (typeof scoreInfo.score !== 'number' && !parseInt(scoreInfo.score))) {
      logger.error('score must be a number or a number to string')
    } else {
      this.pm.removeAll(GAME_EVENTS.REPORT_SCORE_RESULT)
      this.pm.on(GAME_EVENTS.REPORT_SCORE_RESULT, ({ data }: { data: CallbackData }) => {
        callback(data)
      })

      this.pm.emit(GAME_EVENTS.REPORT_SCORE, {
        scoreInfo
      })
    }
  }

  /**
   * 打开排行榜窗口
   */
  public showRankModal() {
    logger.info(`show rank modal`)

    this.pm.emit(GAME_EVENTS.SHOW_RANK_MODAL)
  }
}

export default Rank
